import React from 'react';
import { useNavigate } from 'react-router-dom';
import DesignServicesRoundedIcon from '@mui/icons-material/DesignServicesRounded';
import {
  StyledGatingDialog,
  GatingModalTitle,
  GatingModalContent,
  GatingLeadText,
  GatingModalActions,
  SecondaryGatingButton,
  PrimaryGatingButton,
} from '../GatingDialog.styled';

/**
 * Dismissible reminder for business users who haven't configured any services yet.
 * Shown when the business has no `Services` configured.
 */
function ServicesNotConfiguredModal({ open, onClose }) {
  const navigate = useNavigate();

  return (
    <StyledGatingDialog open={open} onClose={onClose}>
      <GatingModalTitle>
        <span className="gating-modal-icon-wrap" aria-hidden>
          <DesignServicesRoundedIcon className="gating-modal-icon" />
        </span>
        Add your services
      </GatingModalTitle>

      <GatingModalContent>
        <GatingLeadText>
          You haven&apos;t configured any services yet, so customers can&apos;t
          find or request them. Add services to your catalog whenever you&apos;re
          ready.
        </GatingLeadText>
      </GatingModalContent>

      <GatingModalActions>
        <SecondaryGatingButton variant="outlined" onClick={onClose}>
          Maybe later
        </SecondaryGatingButton>
        <PrimaryGatingButton
          variant="contained"
          onClick={() => {
            navigate('/dashboard/service-catalog');
            onClose();
          }}
        >
          Configure services
        </PrimaryGatingButton>
      </GatingModalActions>
    </StyledGatingDialog>
  );
}

export default ServicesNotConfiguredModal;
